import React from "react"
import styles from "./RecommendOffers.module.css"
import { FavoriteOffersProvider } from "../Features/JobList/FavoriteOffersContext"
import RecommendOfferCard from "./RecommendOfferCard"
import MoreOffersCard from "./MoreOffersCard"
import { RecommendOffer } from "./types"

// 計測ラベル(タグ一覧シート準拠)。カードは序数(1st〜3rd)、他の求人を見るは4th。
const LABEL_BASE = "Thanks_CT_Recommended-Offers_レコメンド求人-新規会員登録"
const CARD_ORDINALS = ["1st", "2nd", "3rd"]
const MORE_ORDINAL = "4th"

type RecommendOffersProps = {
    /** レコメンド求人(最大3件)。0件ならこの枠ごと非表示 */
    offers: RecommendOffer[]
    moreOffersHref: string
}

export default function RecommendOffers({
    offers,
    moreOffersHref,
}: RecommendOffersProps) {
    const listRef = React.useRef<HTMLDivElement>(null)
    const [activeIndex, setActiveIndex] = React.useState(0)

    // 横スクロール位置から、ビューポート中央に最も近いカードを現在位置(ドット)とする
    const handleScroll = () => {
        const el = listRef.current
        if (!el) return
        const viewCenter = el.scrollLeft + el.clientWidth / 2
        const children = Array.from(el.children) as HTMLElement[]
        let nearest = 0
        let min = Infinity
        children.forEach((child, i) => {
            const childCenter = child.offsetLeft + child.offsetWidth / 2
            const distance = Math.abs(childCenter - viewCenter)
            if (distance < min) {
                min = distance
                nearest = i
            }
        })
        setActiveIndex(nearest)
    }

    if (!offers || offers.length === 0) {
        return null
    }

    const offerIds = offers.map(offer => offer.offerId)
    // カード + 「他の求人を見る」カードぶんのドット
    const dotCount = offers.length + 1

    return (
        <section className={styles.recommend}>
            <p className={styles.heading}>
                あなたにおすすめの求人が
                <br />
                見つかりました！
            </p>
            <FavoriteOffersProvider offerIds={offerIds}>
                <div
                    className={styles.list}
                    ref={listRef}
                    onScroll={handleScroll}
                >
                    {offers.map((offer, i) => (
                        <RecommendOfferCard
                            key={offer.offerId}
                            offer={offer}
                            analyticsLabel={`${LABEL_BASE}-${CARD_ORDINALS[i]}`}
                        />
                    ))}
                    <MoreOffersCard
                        href={moreOffersHref}
                        analyticsLabel={`${LABEL_BASE}-${MORE_ORDINAL}`}
                    />
                </div>
            </FavoriteOffersProvider>
            <div className={styles.stepper} aria-hidden="true">
                {Array.from({ length: dotCount }).map((_, i) => (
                    <span
                        key={i}
                        className={`${styles.dot} ${
                            i === activeIndex ? styles.dotActive : ""
                        }`}
                    />
                ))}
            </div>
        </section>
    )
}
